module.exports = __webpack_public_path__ + "static/scale-model-of-browns-point-lighthouse-park-in-tacoma-washington-4e49036b5972f57eeb4bd93f6a46d19d.png";